import React, { Component, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import CommonAlert from "../common/Commonalert";
import Sidebar from "../common/sidebar";
import ShowAlert from "../common/Showalert";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";
const MODULE = "manage_masterentry";

const EditDepot = () => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const [mainDepot, setMainDepot] = useState([]);
  const [subDepot, setSubDepot] = useState([]);
  const [premastervalue, setPreMastervalue] = useState([]);
  const [errors, setErrors] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [alerterrorPopup, setAlertErrorPopup] = useState(false);
  const [alerterrMessage, setAlerterrMessage] = useState([]);
  const [depotList, setDepotList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_masterentry")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    setIsLoading(true);
    let URL = BaseUrl + `admin/getdepot/${params.id}`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data[0];
        console.log(responseData);
        setMainDepot(responseData.mainDepot);
        setSubDepot(responseData.subDepot);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
    let URL1 = BaseUrl + `admin/getdepots`;
    http
      .get(URL1)
      .then((response) => {
        let responseData1 = response.data.data;
        setDepotList(responseData1);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const routeChange = () => {
    window.location.href = `/depot`;
  };

  const btnsubmit = (e) => {
    e.preventDefault();
    if (isReadOnly) return;
    const isValid = formvalidation();
    if (isValid) {
      let payload = {
        mainDepot: mainDepot.trim(),
        subDepot: subDepot.trim(),
        id: params.id,
      };
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + "admin/editdepot";
      http
        .put(URL, payload)
        .then(async (response) => {
          let responseData = response.data.data;
          if (response.data.success === true) {
            setAlertPopup(true);
            setAlertMessage(t("depot_updated_successfully_txt"));
            setTimeout(() => {
              routeChange();
            }, 2000);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const formvalidation = () => {
    const errmsg = {};
    let isValid = true;
    const hasDupicateEntry = depotList
      .filter((dataa) => dataa._id != params.id)
      .some(
        (depot) =>
          depot.mainDepot.toLowerCase() === mainDepot.trim().toLowerCase() &&
          depot.subDepot.toLowerCase() === subDepot.trim().toLowerCase(),
      );
    if (!mainDepot.trim()) {
      errmsg.mainDepot = t("field_required_txt");
      isValid = false;
    }
    if (!subDepot.trim()) {
      errmsg.subDepot = t("field_required_txt");
      isValid = false;
    }
    if (hasDupicateEntry) {
      var alertmsg = "";
      alertmsg = t("duplicate_depot_error_txt");
      setAlertErrorPopup(true);
      setAlerterrMessage(alertmsg);
      isValid = false;
    }
    setErrors(errmsg);
    return isValid;
  };

  const handleOnChange = (e) => {
    const re = /^[a-zA-Z0-9-' &.]*$/;
    if (e.target.name === "mainDepot") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setMainDepot(e.target.value);
      }
    }
    if (e.target.name === "subDepot") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setSubDepot(e.target.value);
      }
    }
    const { name, value } = e.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  return (
    <section className="dashboard-block">
      {alerterrorPopup && <ShowAlert title={t("alert_txt")} message={alerterrMessage} />}
      {alertPopup && <CommonAlert title={t("alert_txt")} message={alertMessage} />}
      <div className="dash-right">
        <Sidebar />
      </div>
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
              <h1 className="checkout-title">
                {canEdit ? t("edit_depot_txt") : t("view_depot_txt")}
              </h1>
              <div className="right-table-outer-wrap">
              {isLoading ? (
                  <div className="loading-buffer"></div>
                ) : (
              <div className="form-field freeproduct-fieldset ingredients-fieldset form-container-xs">
                <form className="sectors-detail-form">
                  <div className="input-field">
                    <label htmlFor="mainDepot">{t("main_depot_txt")}</label>
                    <input
                      type="text"
                      name="mainDepot"
                      id="mainDepot"
                      value={mainDepot}
                      onChange={handleOnChange}
                      readOnly={isReadOnly}
                    />
                    {errors.mainDepot && (
                      <div className="error-msg">{errors.mainDepot}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <label htmlFor="subDepot">{t("local_depot_txt")}</label>
                    <input
                      type="text"
                      name="subDepot"
                      id="subDepot"
                      value={subDepot}
                      onChange={handleOnChange}
                      readOnly={isReadOnly}
                    />
                    {errors.subDepot && (
                      <div className="error-msg">{errors.subDepot}</div>
                    )}
                  </div>
                  <div className="btnfield">
                    {canEdit && (
                      <button
                        title={t("update_txt")}
                        type="submit"
                        name="btnsubmit"
                        onClick={btnsubmit}
                      >
                        {t("update_txt")}
                      </button>
                    )}
                    <button title={t("cancel_txt")} type="button" onClick={routeChange}>
                      {t("cancel_txt")}
                    </button>
                  </div>
                </form>
              </div>
              )}
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};
export default EditDepot;
